<template>
  <b-badge :variant="variant">{{ status }}</b-badge>
</template>

<script>
export default {
  name: "MLCNotificationStatus",
  props: {
    status: {
      type: String,
      default: "PENDING",
    },
  },
  computed: {
    variant() {
      switch (this.status) {
        case "SENT":
          return "success";
        case "FAILED":
          return "danger";
        case "PENDING":
          return "warning";
        default:
          return "secondary";
      }
    },
  },
};
</script>
